import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const RulesetDecoderTestSidebar = ({ isOpen, onClose, type }) => {
  const [logs, setLogs] = useState("");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const token = Cookies.get("token");
  const [testSessionToken, setTestSessionToken] = useState("");

  const handleTest = (e) => {
    e.preventDefault();
    axios
      .put(
        `/api/system/logtest`,
        { log: logs },
        {
          headers: {
            "x-auth-token": token,
          },
        }
      )
      .then((res) => {
        setResult(res.data.data);
        setTestSessionToken(res.data.data.token);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleClear = (e) => {
    e.preventDefault();
    axios
      .delete(`/api/system/logtest/sessions/${testSessionToken}`, {
        headers: {
          "x-auth-token": token,
        },
      })
      .then(() => {
        setResult("");
        setError("");
        setTestSessionToken("");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const isEmptyObject = (obj) => obj && Object.keys(obj).length === 0;

  return (
    <div
      className={`fixed top-0 right-0 w-full max-w-lg h-full bg-white border-l border-gray-200 shadow-lg transition-transform duration-300 z-50 ${
        isOpen ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="flex justify-between items-center p-4 border-b">
        <h2 className="text-lg font-semibold">{type} Test</h2>
        <button onClick={onClose} className="text-gray-600 hover:text-black">
          ✕
        </button>
      </div>

      <div className="p-4 flex flex-col h-full">
        <textarea
          placeholder="Type one log per line..."
          value={logs}
          onChange={(e) => setLogs(e.target.value)}
          className="w-full h-40 p-2 border border-gray-300 rounded resize-none font-mono text-sm"
        ></textarea>

        <div className="flex justify-between mt-4">
          <button
            onClick={handleTest}
            disabled={loading || !logs.trim()}
            className={`px-4 py-1 rounded text-sm text-white ${
              loading || !logs.trim()
                ? "bg-blue-300 cursor-not-allowed"
                : "bg-blue-500 hover:bg-blue-600"
            } `}
          >
            <i class="ri-play-line"></i>
            {loading ? "Testing..." : "Test"}
          </button>
          <button
            onClick={handleClear}
            className={`${
              testSessionToken.length > 0
                ? "bg-red-500 text-white"
                : "bg-gray-300 text-gray-700"
            } px-4 py-1 rounded text-sm`}
          >
            <i className="ri-delete-bin-5-line pr-2"></i>Clear session
          </button>
        </div>

        <div className="mt-4 bg-gray-100 p-3 h-[60vh] overflow-auto text-sm font-mono whitespace-pre-wrap border border-gray-200 rounded">
          {error && <span className="text-red-600">{error}</span>}
          {!error && result && (
            <div
              style={{
                marginTop: "2rem",
                background: "#f9f9f9",
                padding: "1rem",
                borderRadius: "5px",
                fontFamily: "monospace",
                whiteSpace: "pre-wrap",
              }}
            >
              <strong>**Messages:</strong>
              <br />
              INFO: (7202): Session initialized with token '{result.token}'
              <br />
              <br />
              <strong>**Phase 1: Completed pre-decoding.</strong>
              <br />
              {result.output?.full_log && (
                <>
                  full event: '{result.output.full_log}'<br />
                </>
              )}
              {result.output?.predecoder?.timestamp && (
                <>
                  timestamp: '{result.output.predecoder.timestamp}'<br />
                </>
              )}
              {result.output?.predecoder?.hostname && (
                <>
                  hostname: '{result.output.predecoder.hostname}'<br />
                </>
              )}
              {result.output?.predecoder?.program_name && (
                <>
                  program_name: '{result.output.predecoder.program_name}'<br />
                </>
              )}
              <br />
              <strong>**Phase 2: Completed decoding.</strong>
              <br />
              {!result.output?.decoder ||
              isEmptyObject(result.output.decoder) ? (
                <>
                  No decoder matched.
                  <br />
                </>
              ) : (
                <>
                  {result.output.decoder.name && (
                    <>
                      name: '{result.output.decoder.name}'<br />
                    </>
                  )}
                  {result.output.decoder.parent && (
                    <>
                      parent: '{result.output.decoder.parent}'<br />
                    </>
                  )}
                  {result.output?.data?.dstuser && (
                    <>
                      dstuser: '{result.output.data.dstuser}'<br />
                    </>
                  )}
                  {result.output?.data?.srcip && (
                    <>
                      srcip: '{result.output.data.srcip}'<br />
                    </>
                  )}
                  {result.output?.data?.srcport && (
                    <>
                      srcport: '{result.output.data.srcport}'<br />
                    </>
                  )}
                </>
              )}
              <br />

              {result.output?.decoder &&
                !isEmptyObject(result.output.decoder) && (
                  <>
                    <strong>**Phase 3: Completed filtering (rules).</strong>
                    <br />
                    {result.output?.rule?.id && (
                      <>
                        id: '{result.output.rule.id}'<br />
                      </>
                    )}
                    {result.output?.rule?.level && (
                      <>
                        level: '{result.output.rule.level}'<br />
                      </>
                    )}
                    {result.output?.rule?.description && (
                      <>
                        description: '{result.output.rule.description}'<br />
                      </>
                    )}
                    {result.output?.rule?.groups?.length > 0 && (
                      <>
                        groups: {JSON.stringify(result.output.rule.groups)}
                        <br />
                      </>
                    )}
                    {result.output?.rule?.firedtimes !== undefined && (
                      <>
                        firedtimes: '{result.output.rule.firedtimes}'<br />
                      </>
                    )}
                    {result.output?.rule?.mail !== undefined && (
                      <>
                        mail: '{result.output.rule.mail ? "true" : "false"}'
                        <br />
                      </>
                    )}
                    {result.output?.rule?.pci_dss?.length > 0 && (
                      <>
                        pci_dss: {JSON.stringify(result.output.rule.pci_dss)}
                        <br />
                      </>
                    )}
                    <br />

                    <strong>**Alert to be generated.</strong>
                  </>
                )}
            </div>
          )}
          {!error && !result && (
            <span className="text-gray-400">
              The test result will appear here.
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default RulesetDecoderTestSidebar;
